import { render, staticRenderFns } from "./SubmitDocumentBtn.vue?vue&type=template&id=7035f271&"
import script from "./SubmitDocumentBtn.vue?vue&type=script&lang=ts&"
export * from "./SubmitDocumentBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports